export const StageOptions = [
    {
        label: '学前',
        value: 6003004,
        children: [{
            label: '小班',
            value: 6004023,
        }, {
            label: '中班',
            value: 6004024,
        }, {
            label: '大班',
            value: 6004025,
        }]
    },
    {
        label: '小学',
        value: 6003001,
        children: [{
            label: '一年级',
            value: 6004001,
        }, {
            label: '二年级',
            value: 6004002,
        }, {
            label: '三年级',
            value: 6004003,
        }, {
            label: '四年级',
            value: 6004004,
        }, {
            label: '五年级',
            value: 6004005,
        }, {
            label: '六年级',
            value: 6004006,
        }]
    }, {
        label: '初中',
        value: 6003002,
        children: [{
            label: '六年级',
            value: 6004006,
        },{
            label: '七年级',
            value: 6004007,
        }, {
            label: '八年级',
            value: 6004008,
        }, {
            label: '九年级',
            value: 6004009,
        }]
    }, {
        label: '高中',
        value: 6003003,
        children: [{
            label: '高一',
            value: 6004010,
        }, {
            label: '高二',
            value: 6004011,
        }, {
            label: '高三',
            value: 6004012,
        }, 
        // {
        //     label: '高四',
        //     value: 6004013,
        // }
    ]
    },
    // {
    //     label: '其他',
    //     value: 6003005,
    //     children: [{
    //         label: '通用',
    //         value: 6004020,
    //     }]
    // }
]
let primarySchool=[{value:6012001,label:"语文","parentid":0,"sort":1,"type":6012,"typeName":null,"createTime":"2019-11-07 13:58:40"},{value:6012002,label:"数学","parentid":0,"sort":2,"type":6012,"typeName":null,"createTime":"2019-11-07 13:58:40"},{value:6012003,label:"英语","parentid":0,"sort":3,"type":6012,"typeName":null,"createTime":"2019-11-07 13:58:40"},{value:6012100,label:"其他","parentid":0,"sort":100,"type":6012,"typeName":null,"createTime":"2019-11-07 13:58:40"}]
let juniorHighSchool= [{value:6012001,label:"语文","parentid":0,"sort":1,"type":6012,"typeName":null,"createTime":"2019-11-07 13:58:40"},{value:6012002,label:"数学","parentid":0,"sort":2,"type":6012,"typeName":null,"createTime":"2019-11-07 13:58:40"},{value:6012003,label:"英语","parentid":0,"sort":3,"type":6012,"typeName":null,"createTime":"2019-11-07 13:58:40"},{value:6012004,label:"化学","parentid":0,"sort":4,"type":6012,"typeName":null,"createTime":"2019-11-07 13:58:40"},{value:6012005,label:"物理","parentid":0,"sort":5,"type":6012,"typeName":null,"createTime":"2019-11-07 13:58:40"},{value:6012006,label:"生物","parentid":0,"sort":6,"type":6012,"typeName":null,"createTime":"2019-11-07 13:58:40"},{value:6012007,label:"地理","parentid":0,"sort":7,"type":6012,"typeName":null,"createTime":"2019-11-07 13:58:40"},{value:6012100,label:"其他","parentid":0,"sort":100,"type":6012,"typeName":null,"createTime":"2019-11-07 13:58:40"}]
export const StageSubjectOptions = [
    {
        label: '学前',
        value: 6003004,
        children: [{
            label: '小班',
            value: 6004023,
        }, {
            label: '中班',
            value: 6004024,
        }, {
            label: '大班',
            value: 6004025,
        }]
    },
    {
        label: '小学',
        value: 6003001,
        children: [{
            label: '一年级',
            value: 6004001,
            children: primarySchool
        }, {
            label: '二年级',
            value: 6004002,
            children: primarySchool
        }, {
            label: '三年级',
            value: 6004003,
            children: primarySchool
        }, {
            label: '四年级',
            value: 6004004,
            children: primarySchool
        }, {
            label: '五年级',
            value: 6004005,
            children: primarySchool
        }, {
            label: '六年级',
            value: 6004006,
            children: primarySchool
        }]
    }, {
        label: '初中',
        value: 6003002,
        children: [{
            label: '六年级',
            value: 6004006,
            children:juniorHighSchool
        },{
            label: '七年级',
            value: 6004007,
            children:juniorHighSchool
        }, {
            label: '八年级',
            value: 6004008,
            children:juniorHighSchool
        }, {
            label: '九年级',
            value: 6004009,
            children:juniorHighSchool
        }]
    }, {
        label: '高中',
        value: 6003003,
        children: [{
            label: '高一',
            value: 6004010,
            children:juniorHighSchool
        }, {
            label: '高二',
            value: 6004011,
            children:juniorHighSchool
        }, {
            label: '高三',
            value: 6004012,
            children:juniorHighSchool
        }, 
        // {
        //     label: '高四',
        //     value: 6004013,
        //     children:juniorHighSchool
        // }
    ]
    }
]
//进步分数
export const improveScoresColumn = [
    { id: 0, name: '全部' },
    { id: 1, name: '5～10分' },
    { id: 2, name: '10分以上' },
    { id: 3, name: '20分以上' },
    { id: 4, name: '30分以上' },
    { id: 5, name: '40分以上' },
]

    //入学成绩
export const enterScoresColumn = [

    { id: 0, name: '全部' },
    { id: 1, name: '40分以下' },
    { id: 2, name: '41～60分' },
    { id: 3, name: '61～80分' },
    { id: 4, name: '81分及以上' },
]
